export function initReveal(scope = document) {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  const elements = scope.querySelectorAll('.reveal:not(.is-observed)');
  if (!elements.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-in');
        observer.unobserve(entry.target); 
      });
    },
    {
      rootMargin: '0px 0px -15% 0px',
      threshold: 0.01
    }
  );

  elements.forEach((el) => {
    el.classList.add('is-observed');
    observer.observe(el);
  });
}